import { tempDocumentsAPI } from "../tempDocumentsApi";

type CreateTemporaryDocumentArgs = {
    apiBaseUrl: string;
    documentId: string | number;
    token: string;
    ttlSeconds?: number;
};

export type CreateTemporaryDocumentResponse = {
    ok: boolean;
    downloadUrl: string;
};

export const tempDocumentsApiSlice = tempDocumentsAPI.injectEndpoints({
    endpoints: builder => ({
        createTemporaryIndorRoadDocument: builder.mutation<CreateTemporaryDocumentResponse, CreateTemporaryDocumentArgs>({
            query: ({ apiBaseUrl, documentId, token, ttlSeconds = 300 }) => ({
                url: "documents",
                method: "POST",
                body: {
                    provider: "iros-rest",
                    source: {
                        apiBaseUrl,
                        documentId: String(documentId),
                        token,
                    },
                    options: {
                        ttlSeconds,
                    },
                },
            }),
        }),
    }),
});

export const {
    useCreateTemporaryIndorRoadDocumentMutation,
} = tempDocumentsApiSlice;
